module.exports = __webpack_public_path__ + "static/media/0141_Small.49eb2ab1.jpg";